// extracted by css-extract-rspack-plugin
export default {"heading":"_de060d08"};